type MarkType = 'start' | 'finish' | 'mark' | 'finish/mark';

export class EditMarkData {
  createUser: string;
  delTime: number;
  delUser: string;
  editUser: string;
  markTime: number;
  marshal: number;
  markDate!: Date;
  delDate!: Date | null;
  type: MarkType;
  expanded: boolean;
  timeSincePreviousMark: string = '';

  constructor(obj: any, type: MarkType) {
    this.createUser = obj.createUser || '';
    this.delTime = obj.delTime;
    this.delUser = obj.delUser || '';
    this.editUser = obj.editUser || '';
    this.markTime = obj.markTime;
    this.marshal = obj.marshal;
    if (this.markTime) {
      const dateMark = new Date();
      dateMark.setTime(this.markTime);
      this.markDate = dateMark;
    }
    this.type = type;
    if (this.delTime) {
      const dateDel = new Date();
      dateDel.setTime(this.delTime);
      this.delDate = dateDel;
    }
    if (obj.markDate) this.markDate = obj.markDate;
    this.expanded = false;
  }
}
